// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Colors
import colors from "assets/theme/base/colors";

import PageLayout from "../PageLayout";
import Footer from "../../examples/Footer";
import { useEffect, useState } from "react";
import { getLangLocalStorage, setLangLocalStorage } from "../../providers/LanguageProvider";
import SuiSelect from "../../components/SuiSelect";
import { dark } from "@mui/material/styles/createPalette";
function CoverLayout({
  color,
  header,
  title,
  description,
  image,
  loginText,
  loginImageCover,
  top,
  children,
}) {
  const { rapidoLogin } = colors;
  const [lang, setLang] = useState();
  const [languages, setLanguages] = useState();
  const getLanguages = () => {
    if (localStorage.getItem("langs")) {
      const options = JSON.parse(localStorage.getItem("langs")).map((item) => ({
        value: item.lang,
        label: item.title,
      }));
      setLanguages(options);
      getLangLocalStorage().then((lng) => {
        setLang(lng);
      });
    } else {
      setTimeout(() => getLanguages(), 400);
    }
  };

  useEffect(() => {
    getLanguages();
  }, []);

  return (
    <PageLayout background="white">
      <Grid
        container
        justifyContent="center"
        sx={{
          height: "100vh",
          margin: 0,
        }}
      >
        <Grid item xs={0} sm={0} md={0} lg={6} xl={6}>
          <SuiBox
            bgColor={rapidoLogin.main}
            width="100%"
            height="100%"
            display={{ xs: "none", lg: "block" }}
            sx={{
              backgroundImage: `linear-gradient(223deg, #387D7A 0%, #262E3C 100%)`,
            }}
          >
            <SuiBox
              height="100%"
              sx={{
                backgroundImage: `url(${image})`,
                backgroundSize: loginImageCover ? "cover" : "auto",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              alignItems="center"
            >
              <SuiBox />
              <SuiBox mt={2}>
                <SuiTypography
                  fontFamily={"'IBM Plex Sans', sans-serif"}
                  alignSelf={"center"}
                  variant={"h1"}
                  color={"white"}
                  letterSpacing={6}
                  fontSize={80}
                  fontWeight={"bold"}
                >
                  {loginText}
                </SuiTypography>
              </SuiBox>
              <Footer />
            </SuiBox>
          </SuiBox>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
          <Grid container direction={"column"} alignItems={"center"} spacing={2}>
            <Grid item alignSelf={"flex-end"}>
              <SuiBox
                sx={{
                  backgroundColor: `transparent`,
                  borderRadius: "10px",
                }}
                width="90px"
                py={1}
                px={1.5}
                mt={2}
                mr={2}
                shadow={"md"}
                // color="black"
                // display="flex"
                // justifyContent="space-between"
                // alignItems="center"
                // position="absolute"
                // left={1150}
                // zIndex={3}
                // sx={({ palette: { white }, functions: { rgba } }) => ({
                // backgroundColor: rgba(white.main, 0.8),
                // backdropFilter: `saturate(200%) blur(30px)`,
                // })}
              >
                {lang ? (
                  <SuiSelect
                    option={rapidoLogin.main}
                    isLight={false}
                    size="medium"
                    defaultValue={{ value: lang, label: lang.toUpperCase() }}
                    options={languages}
                    onChange={(e) => {
                      setLangLocalStorage(e.value);
                    }}
                  />
                ) : null}
              </SuiBox>
            </Grid>
            <Grid item mt={{ lg: 1, xl: 6 }}>
              <SuiBox
                pt={{ xs: 0, sm: 1, md: 2, lg: 2 }}
                sx={{ minWidth: { md: "50vw", lg: "25vw" }, maxWidth: { md: "51vw", lg: "26vw" } }}
              >
                {!header ? (
                  <>
                    <SuiBox mb={1}>
                      <SuiTypography variant="h3" fontWeight="bold" color={color} textGradient>
                        {title}
                      </SuiTypography>
                    </SuiBox>
                    <SuiTypography variant="body2" fontWeight="regular" color="text">
                      {description}
                    </SuiTypography>
                  </>
                ) : (
                  header
                )}
              </SuiBox>
              <SuiBox p={{ xs: 1.5, md: 2 }}>{children}</SuiBox>
              <SuiBox display={{ sm: "block", lg: "none" }}>
                <Footer />
              </SuiBox>
            </Grid>
          </Grid>
          <SuiBox
            display={{ xs: "none", sm: "none", md: "none", lg: "block" }}
            sx={{
              position: "fixed",
              top: "90%",
              left: { lg: "93%", xl: "95%" },
            }}
          >
            <svg
              id="Group_225"
              data-name="Group 225"
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="60"
              viewBox="0 0 60 60"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect
                    id="Rectangle_156"
                    data-name="Rectangle 156"
                    width="60"
                    height="60"
                    fill="#387d7a"
                  />
                </clipPath>
              </defs>
              <g id="Group_222" data-name="Group 222" clipPath="url(#clip-path)">
                <path
                  id="Path_129"
                  data-name="Path 129"
                  d="M69.431,198.287a.629.629,0,0,0-.218.515v.148a.491.491,0,0,0,.179.417.794.794,0,0,0,.492.136.928.928,0,0,0,.565-.164.624.624,0,0,0,.222-.538v-.694H70.2a1.247,1.247,0,0,0-.772.179"
                  transform="translate(-52.935 -151.516)"
                  fill="#387d7a"
                />
                <path
                  id="Path_130"
                  data-name="Path 130"
                  d="M140.663,190.249a.843.843,0,0,0-.721.306,1.32,1.32,0,0,0-.23.815v1.1a1.321,1.321,0,0,0,.23.815,1,1,0,0,0,1.443,0,1.323,1.323,0,0,0,.23-.815v-1.1a1.322,1.322,0,0,0-.23-.815.844.844,0,0,0-.721-.306"
                  transform="translate(-106.854 -145.505)"
                  fill="#387d7a"
                />
                <path
                  id="Path_131"
                  data-name="Path 131"
                  d="M162.372,194.991h-1.139v2.129h1.139a.919.919,0,0,0,.686-.246.878.878,0,0,0,.242-.643v-.351a.878.878,0,0,0-.242-.643.919.919,0,0,0-.686-.246"
                  transform="translate(-123.313 -149.132)"
                  fill="#387d7a"
                />
                <path
                  id="Path_132"
                  data-name="Path 132"
                  d="M182.346,190.249a.843.843,0,0,0-.721.306,1.323,1.323,0,0,0-.23.815v1.1a1.324,1.324,0,0,0,.23.815,1,1,0,0,0,1.443,0,1.325,1.325,0,0,0,.23-.815v-1.1a1.324,1.324,0,0,0-.23-.815.844.844,0,0,0-.722-.306"
                  transform="translate(-138.734 -145.505)"
                  fill="#387d7a"
                />
                <path
                  id="Path_133"
                  data-name="Path 133"
                  d="M90.412,190.713a1.113,1.113,0,0,0-.339.051.9.9,0,0,0-.288.152.75.75,0,0,0-.2.242.672.672,0,0,0-.074.32v1.591a.672.672,0,0,0,.074.32.748.748,0,0,0,.2.242.9.9,0,0,0,.288.152,1.105,1.105,0,0,0,.339.051.894.894,0,0,0,.71-.3,1.24,1.24,0,0,0,.265-.842v-.827a1.24,1.24,0,0,0-.265-.842.894.894,0,0,0-.71-.3"
                  transform="translate(-68.456 -145.86)"
                  fill="#387d7a"
                />
                <path
                  id="Path_134"
                  data-name="Path 134"
                  d="M120.888,190.916a.9.9,0,0,0-.292-.152,1.128,1.128,0,0,0-.335-.051.894.894,0,0,0-.71.3,1.239,1.239,0,0,0-.265.842v.827a1.239,1.239,0,0,0,.265.842.894.894,0,0,0,.71.3,1.121,1.121,0,0,0,.335-.051.9.9,0,0,0,.292-.152.751.751,0,0,0,.2-.242.675.675,0,0,0,.074-.32v-1.591a.675.675,0,0,0-.074-.32.753.753,0,0,0-.2-.242"
                  transform="translate(-91.231 -145.86)"
                  fill="#387d7a"
                />
                <path
                  id="Path_135"
                  data-name="Path 135"
                  d="M162.875,186.475a.8.8,0,0,0,.215-.585v-.343a.8.8,0,0,0-.215-.585.853.853,0,0,0-.635-.218h-1.006v1.95h1.006a.853.853,0,0,0,.635-.218"
                  transform="translate(-123.313 -141.295)"
                  fill="#387d7a"
                />
                <path
                  id="Path_136"
                  data-name="Path 136"
                  d="M154.317,85.329l-10.428,5.176v7.966h10.428Z"
                  transform="translate(-110.048 -65.261)"
                  fill="#387d7a"
                />
                <path
                  id="Path_137"
                  data-name="Path 137"
                  d="M0,60H60V0H0ZM14.952,48.44h-.6a1.824,1.824,0,0,1-.425-.043.94.94,0,0,1-.308-.133.968.968,0,0,1-.234-.226,2.2,2.2,0,0,1-.195-.324l-.912-1.739H11.5v2.043h.569v.421H10v-.421h.569v-4.6H10V43h2.769a2.312,2.312,0,0,1,.651.086,1.349,1.349,0,0,1,.5.261,1.167,1.167,0,0,1,.32.444,1.614,1.614,0,0,1,.113.628,1.336,1.336,0,0,1-.324.924,1.532,1.532,0,0,1-.877.472L14.1,47.5a1.131,1.131,0,0,0,.339.394.81.81,0,0,0,.456.121h.055Zm4.188-.062a1.213,1.213,0,0,1-.281.109,1.386,1.386,0,0,1-.367.047.681.681,0,0,1-.526-.183.672.672,0,0,1-.168-.472V47.84H17.76a1.263,1.263,0,0,1-.14.253,1.006,1.006,0,0,1-.222.222,1.064,1.064,0,0,1-.332.16,1.608,1.608,0,0,1-.46.059,1.263,1.263,0,0,1-.917-.3,1.1,1.1,0,0,1-.308-.823,1.035,1.035,0,0,1,.421-.9,2.393,2.393,0,0,1,1.373-.3h.562v-.53a1.1,1.1,0,0,0-.21-.725.82.82,0,0,0-.663-.25,1.208,1.208,0,0,0-.577.109v.031a.418.418,0,0,1,.234.406.482.482,0,0,1-.129.351.493.493,0,0,1-.37.133.461.461,0,0,1-.339-.137.5.5,0,0,1-.136-.37.643.643,0,0,1,.105-.347,1,1,0,0,1,.308-.3,1.7,1.7,0,0,1,.5-.21,2.629,2.629,0,0,1,.675-.078,1.588,1.588,0,0,1,1.107.343,1.236,1.236,0,0,1,.374.959v2.433h.53Zm4.609-1.072a2.024,2.024,0,0,1-.327.667,1.4,1.4,0,0,1-.515.417,1.567,1.567,0,0,1-.679.144,1.187,1.187,0,0,1-.737-.21,1.258,1.258,0,0,1-.4-.491h-.039v1.747h.686V50h-2.09v-.421h.53v-4.57l-.53-.1v-.343l1.4-.273v.7h.039A1.249,1.249,0,0,1,21.5,44.5a1.19,1.19,0,0,1,.733-.21,1.567,1.567,0,0,1,.679.144,1.4,1.4,0,0,1,.515.417,2.025,2.025,0,0,1,.327.667,3.462,3.462,0,0,1,0,1.786M26.51,48.44H24.576v-.421h.53v-3.01l-.53-.1v-.343l1.4-.273v3.728h.53Zm-1.5-5.326v-.047a.509.509,0,0,1,.14-.37.6.6,0,0,1,.78,0,.509.509,0,0,1,.14.37v.047a.509.509,0,0,1-.14.37.6.6,0,0,1-.78,0,.509.509,0,0,1-.14-.37m6.325,5.147-1.4.273v-.7h-.039a1.25,1.25,0,0,1-.406.491,1.19,1.19,0,0,1-.733.21,1.567,1.567,0,0,1-.679-.144,1.4,1.4,0,0,1-.515-.417,2.025,2.025,0,0,1-.328-.667,3.469,3.469,0,0,1,0-1.786,2.026,2.026,0,0,1,.328-.667,1.4,1.4,0,0,1,.515-.417,1.567,1.567,0,0,1,.679-.144,1.187,1.187,0,0,1,.737.21,1.265,1.265,0,0,1,.4.491h.039V43.231l-.53-.1v-.343l1.4-.273v5.3l.53.1Zm4.239-.963a1.89,1.89,0,0,1-.386.667,1.694,1.694,0,0,1-.6.421,2.127,2.127,0,0,1-1.56,0,1.694,1.694,0,0,1-.6-.421,1.89,1.89,0,0,1-.386-.667,2.94,2.94,0,0,1,0-1.77,1.891,1.891,0,0,1,.386-.667,1.7,1.7,0,0,1,.6-.421,2.127,2.127,0,0,1,1.56,0,1.7,1.7,0,0,1,.6.421,1.891,1.891,0,0,1,.386.667,2.94,2.94,0,0,1,0,1.77m4.941.741a1.678,1.678,0,0,1-1.193.4h-2.9v-.421h.569v-4.6h-.569V43h2.7a1.777,1.777,0,0,1,1.209.359,1.182,1.182,0,0,1,.405.928,1.3,1.3,0,0,1-.094.511,1.2,1.2,0,0,1-.246.378,1.34,1.34,0,0,1-.347.257,1.437,1.437,0,0,1-.405.14v.039a1.844,1.844,0,0,1,.448.109,1.393,1.393,0,0,1,.421.25,1.3,1.3,0,0,1,.312.4,1.218,1.218,0,0,1,.121.558,1.449,1.449,0,0,1-.429,1.111m4.862-.741a1.893,1.893,0,0,1-.386.667,1.7,1.7,0,0,1-.6.421,2.127,2.127,0,0,1-1.56,0,1.7,1.7,0,0,1-.6-.421,1.886,1.886,0,0,1-.386-.667,2.935,2.935,0,0,1,0-1.77,1.887,1.887,0,0,1,.386-.667,1.7,1.7,0,0,1,.6-.421,2.127,2.127,0,0,1,1.56,0,1.7,1.7,0,0,1,.6.421,1.894,1.894,0,0,1,.386.667,2.94,2.94,0,0,1,0,1.77M50,48.44H48.1v-.421h.468l-.811-1.186h-.039l-.811,1.186h.468v.421H45.905v-.421h.437l1.139-1.536-1.17-1.677h-.382v-.421h1.887v.421h-.468l.8,1.178h.031l.8-1.178H48.5v-.421h1.474v.421H49.54l-1.107,1.528,1.186,1.685H50Zm0-8.755H10V22.436a11.173,11.173,0,0,1,3.239-8.481q3.239-3.094,8.8-3.1a12.18,12.18,0,0,1,7.136,1.978,10.431,10.431,0,0,1,3.982,5.816L50,10Z"
                  fill="#387d7a"
                />
                <path
                  id="Path_138"
                  data-name="Path 138"
                  d="M74.589,75.179H71.851a4.792,4.792,0,0,0-3.678,1.373,5.415,5.415,0,0,0-1.284,3.841V90.708H79.554V80.393a5.415,5.415,0,0,0-1.284-3.841,4.794,4.794,0,0,0-3.681-1.373"
                  transform="translate(-51.158 -57.498)"
                  fill="#387d7a"
                />
                <path
                  id="Path_139"
                  data-name="Path 139"
                  d="M50.781,186v-.367a.868.868,0,0,0-.222-.624.834.834,0,0,0-.636-.234H48.886v2.082h1.037a.835.835,0,0,0,.636-.234.868.868,0,0,0,.222-.624"
                  transform="translate(-37.389 -141.321)"
                  fill="#387d7a"
                />
              </g>
            </svg>
          </SuiBox>
        </Grid>
      </Grid>
    </PageLayout>
  );
}

// Setting default values for the props of CoverLayout
CoverLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  color: "info",
  top: 0,
};

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "rapidoLogin",
    "rapidoDashboard",
  ]),
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string.isRequired,
  top: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
